var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dialog-container" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.fdata.customerName + "-福豆回收",
            visible: _vm.dialogFormVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "div",
            [
              _c("el-alert", {
                staticStyle: { "margin-bottom": "20px" },
                attrs: {
                  title:
                    "温馨提示: 员工积分回收会回收最快到期积分，如积分不够则回收剩余所有积分。",
                  type: "warning",
                  closable: false,
                  "show-icon": "",
                },
              }),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "formRef",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "回收方式：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                          },
                          on: { change: _vm.handleEmpTypeChange },
                          model: {
                            value: _vm.form.customerEmpType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "customerEmpType", $$v)
                            },
                            expression: "form.customerEmpType",
                          },
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              staticStyle: { margin: "10px 0" },
                              attrs: { label: 2 },
                            },
                            [
                              _vm._v("指定回收\n              "),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "text",
                                    disabled: _vm.form.customerEmpType !== 2,
                                  },
                                  on: { click: _vm.openSelectStaff },
                                },
                                [_vm._v("选择员工")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                              },
                              attrs: { label: 3 },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { "margin-right": "8px" } },
                                    [_vm._v("指定员工批量")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "ButtonUploadExcel",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.form.customerEmpType === 3,
                                          expression:
                                            "form.customerEmpType === 3",
                                        },
                                      ],
                                      attrs: { onSuccess: _vm.onSuccess },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  上传文件\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: { click: _vm.download },
                                    },
                                    [_vm._v("下载模板")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.form.customerEmpType === 2 &&
                  _vm.form.customerEmpList &&
                  _vm.form.customerEmpList.length
                    ? _c("el-form-item", { attrs: { label: "已选员工：" } }, [
                        _c(
                          "div",
                          { staticClass: "selected-staff" },
                          _vm._l(_vm.form.customerEmpList, function (item) {
                            return _c(
                              "el-tag",
                              {
                                key: item.id,
                                staticClass: "selected-staff-tag",
                                attrs: {
                                  closable: "",
                                  type: "info",
                                  size: "medium",
                                },
                                on: {
                                  close: function ($event) {
                                    return _vm.removeSelectedStaff(item)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.empName) +
                                    "-" +
                                    _vm._s(item.phone) +
                                    "\n            "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "回收原因：", prop: "reason" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.form.reason,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "reason", $$v)
                          },
                          expression: "form.reason",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "发放批次：", prop: "integralLogId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            clearable: "",
                            placeholder: "请选择",
                            filterable: "",
                          },
                          on: { change: _vm.handleIntegralLogChange },
                          model: {
                            value: _vm.form.integralLogId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "integralLogId", $$v)
                            },
                            expression: "form.integralLogId",
                          },
                        },
                        _vm._l(_vm.sendLogLists, function (item) {
                          return _c(
                            "el-option",
                            {
                              key: item.integralLogId,
                              attrs: {
                                label:
                                  "(id:" +
                                  item.integralLogId +
                                  ")-" +
                                  item.reason,
                                value: item.integralLogId,
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "(id:" +
                                    _vm._s(item.integralLogId) +
                                    ")-" +
                                    _vm._s(item.reason)
                                ),
                                item.sendType === 8
                                  ? _c(
                                      "span",
                                      { staticStyle: { color: "#E6A23C" } },
                                      [_vm._v(" （数据迁移，不可回收）")]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isMigrationBatch
                    ? _c("el-alert", {
                        staticStyle: { "margin-bottom": "16px" },
                        attrs: {
                          title: "该批次为数据迁移生成，不支持回收操作。",
                          type: "warning",
                          closable: false,
                          "show-icon": "",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "项目编号：", prop: "projectNumber" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入项目编号" },
                        model: {
                          value: _vm.form.projectNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "projectNumber", $$v)
                          },
                          expression: "form.projectNumber",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "申请编号：", prop: "applicationNumber" },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入申请编号" },
                        model: {
                          value: _vm.form.applicationNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "applicationNumber", $$v)
                          },
                          expression: "form.applicationNumber",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "公司：", prop: "companyId" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择公司",
                            clearable: "",
                            filterable: "",
                            disabled: !!_vm.form.integralLogId,
                          },
                          model: {
                            value: _vm.form.companyId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "companyId", $$v)
                            },
                            expression: "form.companyId",
                          },
                        },
                        _vm._l(_vm.companyOptions, function (company) {
                          return _c("el-option", {
                            key: company.id,
                            attrs: { label: company.name, value: company.id },
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _vm.form.integralLogId
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#909399",
                                "font-size": "12px",
                                "margin-left": "8px",
                              },
                            },
                            [_vm._v("已根据发放批次自动关联")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "销售价：", prop: "salesPrice" } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: { precision: 2, step: 0.01, min: 0 },
                        model: {
                          value: _vm.form.salesPrice,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "salesPrice", $$v)
                          },
                          expression: "form.salesPrice",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "内部备注：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入", type: "textarea" },
                        model: {
                          value: _vm.form.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入", type: "textarea" },
                        model: {
                          value: _vm.form.innerRemark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "innerRemark", $$v)
                          },
                          expression: "form.innerRemark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("关闭")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.submitting,
                    disabled: _vm.isMigrationBatch || _vm.submitting,
                  },
                  on: { click: _vm.debouncedSubmit },
                },
                [_vm._v("立即回收")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("SelectStaff", {
            ref: "selectStaffRef",
            attrs: { list: _vm.form.customerEmpList },
            on: { update: _vm.handleStaffUpdate },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }